import type {UserApiModel} from '../../../api/user';
import type {UserModel} from '../../../core/domain/User/User.model';
import type {Nullable} from '../../utility-types';

import {envManager} from '../../env';

/**
 * Determines the source/origin of a user in the system.
 *
 * This function evaluates whether a user came from direct registration or through a B2B widget.
 */
export function getUserSource(
  user?: Nullable<UserApiModel>,
): UserModel.UserSource {
  if (!user) {
    return 'direct';
  }

  if (envManager.isB2b) {
    return user.roles?.includes('coach') ? 'direct' : 'b2b_widget';
  }

  if (!user.onboarding?.type) {
    return 'direct';
  }

  return ['b2b_widget', 'external'].includes(user.onboarding?.type)
    ? 'b2b_widget'
    : 'direct';
}
